require('./bootstrap');
require('./jquery-ui');
//import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
